import React, { useState, useEffect } from 'react';
import { TreeTable } from 'primereact/treetable';
import { Column } from 'primereact/column';
import "primereact/resources/themes/lara-light-cyan/theme.css";


export default function HierarchyDataGrid() {

    const data = [  {
        key: '0',
        data: {
            name: 'Applications',
            size: '100kb',
            type: 'Folder'
        },
        children: [
            {
                key: '01',
                data: {
                    name: 'React',
                    size: '25kb',
                    type: 'Folder'
                },
                children: [
                    {
                        key: '010',
                        data: {
                            name: 'react.app',
                            size: '10kb',
                            type: 'Application'
                        },
                        children :[
                            {
                                key: '011',
                                data: {
                                    name: 'react.app 1',
                                    size: '10kb',
                                    type: 'Application'
                                },
                                children :[
                                    {
                                        key: '012',
                                        data: {
                                            name: 'react.app 2',
                                            size: '10kb',
                                            type: 'Application'
                                        }, 
                                    }
                                ]

                            }
                        ]
                    },
                    
                    {
                        key: '020',
                        data: {
                            name: 'native.app',
                            size: '10kb',
                            type: 'Application'
                        }
                    },
                    {
                        key: '021',
                        data: {
                            name: 'mobile.app',
                            size: '5kb',
                            type: 'Application'
                        }
                    }
                ]
            },
            {
                key: '02',
                data: {
                    name: 'editor.app',
                    size: '25kb',
                    type: 'Application'
                }
            },
            {
                key: '03',
                data: {
                    name: 'settings.app',
                    size: '50kb',
                    type: 'Application'
                }
            }
        ]
    },
    {
        key: '1',
        data: {
            name: 'Cloud',
            size: '20kb',
            type: 'Folder'
        },
        children: [
            {
                key: '1-0',
                data: {
                    name: 'backup-1.zip',
                    size: '10kb',
                    type: 'Zip'
                }
            },
            {
                key: '1-1',
                data: {
                    name: 'backup-2.zip',
                    size: '10kb',
                    type: 'Zip'
                }
            }
        ]
    },
    {
        key: '2',
        data: {
            name: 'Desktop',
            size: '150kb',
            type: 'Folder'
        },
        children: [
            {
                key: '2-0',
                data: {
                    name: 'note-meeting.txt',
                    size: '50kb',
                    type: 'Text'
                }
            },
            {
                key: '2-1',
                data: {
                    name: 'note-todo.txt',
                    size: '100kb',
                    type: 'Text'
                }
            }
        ]
    },
    {
        key: '3',
        data: {
            name: 'Documents',
            size: '75kb',
            type: 'Folder'
        },
        children: [
            {
                key: '3-0',
                data: {
                    name: 'Work',
                    size: '55kb',
                    type: 'Folder'
                },
                children: [
                    {
                        key: '3-0-0',
                        data: {
                            name: 'Expenses.doc',
                            size: '30kb',
                            type: 'Document'
                        }
                    },
                    {
                        key: '3-0-1',
                        data: {
                            name: 'Resume.doc',
                            size: '25kb',
                            type: 'Resume'
                        }
                    }
                ]
            },
            {
                key: '3-1',
                data: {
                    name: 'Home',
                    size: '20kb',
                    type: 'Folder'
                },
                children: [
                    {
                        key: '3-1-0',
                        data: {
                            name: 'Invoices',
                            size: '20kb',
                            type: 'Text'
                        }
                    }
                ]
            }
        ]
    },
  
];
    const [nodes, setNodes] = useState(data);
    const [selectedNodeKeys, setSelectedNodeKeys] = useState(null);
    const [filterMode, setFilterMode] = useState('lenient');
  
    console.log(selectedNodeKeys);


    return (
        <div className="card">
            <TreeTable sortMode="multiple" 
                paginator rows={5} 
                rowsPerPageOptions={[5, 10, 25]} 
                value={nodes} 
                filterMode={filterMode} 
                tableStyle={{ minWidth: '50rem' }}
                selectionMode="checkbox" 
                selectionKeys={selectedNodeKeys}
                 onSelectionChange={(e) => setSelectedNodeKeys(e.value)}>
                <Column field="name" header="Name" sortable expander filter filterPlaceholder="Filter by name"></Column>
                <Column field="size" header="Size" sortable filter filterPlaceholder="Filter by size"></Column>
                <Column field="type" header="Type" sortable filter filterPlaceholder="Filter by type"></Column>

            </TreeTable>
        </div>
    )
}